import { render, staticRenderFns } from "./DeclineCertificationModal.vue?vue&type=template&id=665fff1c&scoped=true&"
import script from "./DeclineCertificationModal.vue?vue&type=script&lang=js&"
export * from "./DeclineCertificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665fff1c",
  null
  
)

export default component.exports